(function () {
  'use strict';

  function initCartDrawer() {
    var drawer = document.querySelector('[data-cart-drawer]');
    if (!drawer || drawer.dataset.initialized === 'true') return;
    drawer.dataset.initialized = 'true';

    var panel = drawer.querySelector('.nn-cart-drawer__panel');
    var itemsHost = drawer.querySelector('[data-cart-drawer-items]');
    var emptyState = drawer.querySelector('[data-cart-drawer-empty]');
    var footer = drawer.querySelector('[data-cart-drawer-footer]');
    var status = drawer.querySelector('[data-cart-drawer-status]');
    var headingCount = drawer.querySelector('[data-cart-drawer-heading-count]');
    var subtotalNode = drawer.querySelector('[data-cart-drawer-subtotal]');
    var shippingCostNode = drawer.querySelector('[data-cart-drawer-shipping-cost]');
    var grandTotalNode = drawer.querySelector('[data-cart-drawer-grand-total]');
    var checkoutButton = drawer.querySelector('[data-cart-drawer-checkout]');
    var shippingMessage = drawer.querySelector('[data-cart-drawer-shipping-message]');
    var progress = drawer.querySelector('[data-cart-drawer-progress]');
    var cartUrl = drawer.dataset.cartUrl || '/cart';
    var cartJsonUrl = drawer.dataset.cartJsonUrl || '/cart.js';
    var changeUrl = drawer.dataset.cartChangeUrl || '/cart/change.js';
    var threshold = Number(drawer.dataset.freeShippingThreshold) || 90000;
    var lastFocused = null;
    var closeTimer = null;
    var lastLoadedAt = 0;

    function formatMoney(cents) {
      return new Intl.NumberFormat('tr-TR', {
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format((Number(cents) || 0) / 100) + ' TL';
    }

    function setHeaderCount(count) {
      var node = document.getElementById('CartCount');
      if (node) node.textContent = count > 0 ? 'Sepet (' + count + ')' : 'Sepet';
    }

    function setStatus(message) {
      if (status) status.textContent = message || '';
    }

    function createIconButton(label, className, path) {
      var button = document.createElement('button');
      button.type = 'button';
      button.className = className;
      button.setAttribute('aria-label', label);
      button.innerHTML = '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.7" aria-hidden="true">' + path + '</svg>';
      return button;
    }

    function productSubtotal(cart) {
      return Math.max(0, Number(cart.items_subtotal_price) || 0);
    }

    function updateShipping(cart) {
      var subtotal = productSubtotal(cart);
      if (cart.item_count === 0) {
        if (progress) progress.style.width = '0%';
        if (shippingMessage) shippingMessage.textContent = 'Sepetinize ürün ekleyerek ücretsiz kargo ilerlemesini görün.';
        return;
      }
      var remaining = Math.max(0, threshold - subtotal);
      var percentage = threshold > 0 ? Math.min(100, subtotal * 100 / threshold) : 100;
      if (progress) progress.style.width = percentage + '%';
      if (shippingMessage) {
        shippingMessage.textContent = remaining > 0
          ? 'Ücretsiz kargo için ' + formatMoney(remaining) + ' kaldı'
          : 'Ücretsiz kargo kazandınız!';
      }
    }

    function buildItem(item) {
      var row = document.createElement('article');
      row.className = 'nn-cart-drawer__item';
      row.dataset.cartKey = item.key;

      var imageLink = document.createElement('a');
      imageLink.className = 'nn-cart-drawer__image';
      imageLink.href = item.url || cartUrl;
      if (item.image) {
        var image = document.createElement('img');
        image.src = item.image;
        image.alt = item.product_title || '';
        image.width = 164;
        image.height = 192;
        image.loading = 'lazy';
        imageLink.appendChild(image);
      }

      var details = document.createElement('div');
      details.className = 'nn-cart-drawer__details';

      if (item.vendor) {
        var vendor = document.createElement('p');
        vendor.className = 'nn-cart-drawer__vendor';
        vendor.textContent = item.vendor;
        details.appendChild(vendor);
      }

      var title = document.createElement('a');
      title.className = 'nn-cart-drawer__title';
      title.href = item.url || cartUrl;
      title.textContent = item.product_title || item.title || 'Ürün';
      details.appendChild(title);

      if (item.variant_title && item.variant_title !== 'Default Title') {
        var variant = document.createElement('p');
        variant.className = 'nn-cart-drawer__variant';
        variant.textContent = item.variant_title;
        details.appendChild(variant);
      }

      var qty = document.createElement('div');
      qty.className = 'nn-cart-drawer__qty';

      var minus = document.createElement('button');
      minus.type = 'button';
      minus.setAttribute('aria-label', 'Adedi azalt');
      minus.textContent = '−';
      minus.addEventListener('click', function () { changeQuantity(item.key, Math.max(0, item.quantity - 1), row); });

      var count = document.createElement('span');
      count.textContent = item.quantity;
      count.setAttribute('aria-label', 'Adet: ' + item.quantity);

      var plus = document.createElement('button');
      plus.type = 'button';
      plus.setAttribute('aria-label', 'Adedi artır');
      plus.textContent = '+';
      plus.addEventListener('click', function () { changeQuantity(item.key, item.quantity + 1, row); });

      qty.appendChild(minus);
      qty.appendChild(count);
      qty.appendChild(plus);
      details.appendChild(qty);

      var price = document.createElement('p');
      price.className = 'nn-cart-drawer__line-price';
      price.textContent = formatMoney(item.final_line_price);
      details.appendChild(price);

      var remove = createIconButton(
        'Ürünü kaldır',
        'nn-cart-drawer__remove',
        '<path d="M4 7h16M9 7V4h6v3M7 7l1 13h8l1-13M10 11v5M14 11v5"/>'
      );
      remove.addEventListener('click', function () { changeQuantity(item.key, 0, row); });

      row.appendChild(imageLink);
      row.appendChild(details);
      row.appendChild(remove);
      return row;
    }

    function render(cart) {
      itemsHost.innerHTML = '';
      setHeaderCount(cart.item_count);
      if (headingCount) headingCount.textContent = '(' + cart.item_count + ' ürün)';
      var subtotal = productSubtotal(cart);
      var isEmpty = cart.item_count === 0;
      if (subtotalNode) subtotalNode.textContent = formatMoney(subtotal);
      if (shippingCostNode) shippingCostNode.textContent = isEmpty ? '—' : 'Ödeme adımında';
      if (grandTotalNode) grandTotalNode.textContent = formatMoney(subtotal);
      updateShipping(cart);

      cart.items.forEach(function (item) {
        itemsHost.appendChild(buildItem(item));
      });

      emptyState.hidden = !isEmpty;
      footer.hidden = isEmpty;
      checkoutButton.disabled = isEmpty;
      setStatus('');
    }

    function loadCart() {
      drawer.classList.add('is-loading');
      setStatus('');
      return fetch(cartJsonUrl, { headers: { Accept: 'application/json' } })
        .then(function (response) {
          if (!response.ok) throw new Error('Sepet yüklenemedi');
          return response.json();
        })
        .then(function (cart) {
          render(cart);
          lastLoadedAt = Date.now();
          return cart;
        })
        .catch(function () {
          setStatus('Sepetiniz şu anda görüntülenemiyor. Sepet sayfasına gidebilirsiniz.');
        })
        .finally(function () {
          drawer.classList.remove('is-loading');
        });
    }

    function changeQuantity(key, quantity, row) {
      if (row) row.classList.add('is-loading');
      setStatus('');
      fetch(changeUrl, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: key, quantity: quantity })
      })
        .then(function (response) {
          if (!response.ok) throw new Error('Sepet güncellenemedi');
          return response.json();
        })
        .then(render)
        .catch(function () {
          if (row) row.classList.remove('is-loading');
          setStatus('Sepet güncellenemedi. Lütfen tekrar deneyin.');
        });
    }

    function openDrawer(event, skipReload) {
      if (event) event.preventDefault();
      window.clearTimeout(closeTimer);
      if (drawer.hidden) lastFocused = document.activeElement;
      drawer.hidden = false;
      requestAnimationFrame(function () {
        requestAnimationFrame(function () {
          drawer.classList.add('is-open');
          document.body.classList.add('nn-cart-drawer-open');
          document.querySelectorAll('[data-cart-drawer-open]').forEach(function (trigger) {
            trigger.setAttribute('aria-expanded', 'true');
          });
        });
      });
      if (skipReload) {
        drawer.classList.add('is-loading');
      } else if (!lastLoadedAt) {
        loadCart();
      } else if (Date.now() - lastLoadedAt > 10000) {
        window.setTimeout(loadCart, 430);
      }
      if (panel) panel.focus();
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      document.body.classList.remove('nn-cart-drawer-open');
      document.querySelectorAll('[data-cart-drawer-open]').forEach(function (trigger) {
        trigger.setAttribute('aria-expanded', 'false');
      });
      closeTimer = window.setTimeout(function () {
        drawer.hidden = true;
      }, 430);
      if (lastFocused && typeof lastFocused.focus === 'function') lastFocused.focus();
    }

    document.querySelectorAll('[data-cart-drawer-open]').forEach(function (trigger) {
      trigger.addEventListener('click', openDrawer);
    });
    drawer.querySelectorAll('[data-cart-drawer-close]').forEach(function (trigger) {
      trigger.addEventListener('click', closeDrawer);
    });
    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && !drawer.hidden) closeDrawer();
      if (event.key === 'Tab' && !drawer.hidden && panel) {
        var focusable = Array.prototype.slice.call(panel.querySelectorAll('a[href], button:not(:disabled), input:not(:disabled), [tabindex="0"]')).filter(function (node) { return node.getClientRects().length > 0; });
        var first = focusable[0];
        var last = focusable[focusable.length - 1];
        if (!first) { event.preventDefault(); panel.focus(); return; }
        if (event.shiftKey && (document.activeElement === first || document.activeElement === panel)) { event.preventDefault(); last.focus(); }
        else if (!event.shiftKey && (document.activeElement === last || document.activeElement === panel)) { event.preventDefault(); first.focus(); }
      }
    });
    document.addEventListener('cart:added', function () {
      openDrawer(null, true);
    });
    document.addEventListener('cart:updated', function (event) {
      if (event.detail && event.detail.cart) {
        render(event.detail.cart);
        drawer.classList.remove('is-loading');
        lastLoadedAt = Date.now();
      } else if (!drawer.hidden) {
        loadCart();
      }
    });

    var preloadCart = function () { loadCart(); };
    if ('requestIdleCallback' in window) {
      window.requestIdleCallback(preloadCart, { timeout: 1200 });
    } else {
      window.setTimeout(preloadCart, 450);
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initCartDrawer);
  } else {
    initCartDrawer();
  }
})();
